"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadMoreModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../dsl/front");
const ui_1 = require("../_abstract/ui");
const _contracts_1 = require("../_contracts");
const ui_2 = require("../_components/ui");
const prepare_image_1 = require("../_filters/prepare-image");
/**
 * Component capable of rendering the `ReadMoreModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let ReadMoreModuleUi = class ReadMoreModuleUi extends ui_1.AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * Articles to render.
         */
        this.articles = [];
        /**
         * @inheritDoc
         */
        this.imageRatios = {
            desktop: _contracts_1.ImageRatio.Tile,
            mobile: _contracts_1.ImageRatio.Tile
        };
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        const itemsToResolve = Array.isArray(this.module.content.articles) ? this.module.content.articles : [];
        try {
            const resolvedArticles = await Promise.all(itemsToResolve.map(item => {
                return new Promise((resolve, reject) => {
                    this.relatedService.resolve(item, {})
                        .then(article => {
                        resolve(article);
                    })
                        .catch(e => {
                        if (this.debug)
                            console.warn(e);
                        reject(e);
                    });
                });
            }));
            this.articles = resolvedArticles;
            this.articles.forEach(article => {
                article.thumbnail = this.getThumbnail(article);
            });
        }
        catch (e) {
            this.onError(e);
        }
        this.articles.length > 0 ? this.onReady() : this.onError();
    }
    /**
     * Resolves the applicable `Image` for the current screen resolution.
     */
    getThumbnail(article) {
        if (typeof article.properties.cover !== 'object' || typeof article.properties.cover === null ||
            typeof article.properties.cover.image !== 'object' || article.properties.cover.image === null) {
            return;
        }
        const maxWidth = this.isMobile ? 90 * 2 : 120 * 2;
        return prepare_image_1.prepareImage(article.properties.cover.image, this.imageRatio, maxWidth, this.module.isLazyLoaded);
    }
    /**
     * Returns the title of the given article, depending on the `titleVersion` prop.
     * @param article
     */
    getTitle(article) {
        if (!this.titleVersion) {
            return article.title;
        }
        if (typeof article.properties.additionalTitles !== 'object' || article.properties.additionalTitles === null ||
            !article.properties.additionalTitles[this.titleVersion]) {
            return article.title;
        }
        return article.properties.additionalTitles[this.titleVersion];
    }
    /**
     * TODO: Getter description.
     */
    get titleVersion() {
        return this.module.content.titleVersion;
    }
};
ReadMoreModuleUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'ReadMoreModuleUi',
        components: {
            BootstrapImage: front_1.BootstrapImage,
            BootstrapLink: front_1.BootstrapLink,
            LineHeader: ui_2.LineHeader
        },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <section class="read-more module defence-ads" :class="[debugClass, loadingClass]">

    <!-- Module header -->
    <LineHeader :showPointer="false" class="mb-0" v-if="(articles && articles.length)">
      {{ $t('_.read-more') }}
    </LineHeader>

    <ul class="list-unstyled">

      <!-- Single article -->
      <li v-for="(article, i) in articles" :key="article.urlPath + '-' + i"
          class="read-more__article position-relative border-bottom">
        <div class="row align-items-md-center">

          <!-- Article thumbnail -->
          <div v-if="module.content.showThumbnails && !!article.thumbnail" class="col-auto">
            <BootstrapImage v-bind="article.thumbnail"
                            class="read-more__article__thumbnail img-fluid"/>
          </div>

          <!-- Article title -->
          <div class="col">
            <BootstrapLink :link="{ target: article.urlPath }"
                           class="read-more__article__title stretched-link text-body fw-bold text-decoration-none h5">
              {{ getTitle(article) }}
            </BootstrapLink>
            <div v-if="article.sponsored || module.content.showSponsored" class="line-header__content text-ui-separator text-uppercase border-0 mt-1">
              {{ $t('_.sponsored') }}
            </div>
          </div>

        </div>
      </li>
      <!-- END | Single article -->

    </ul>
    </section>
  `
    })
], ReadMoreModuleUi);
exports.ReadMoreModuleUi = ReadMoreModuleUi;
//# sourceMappingURL=ReadMore.ui.js.map